import { Folder } from '@/gql/graphql';
import { TreeViewItemWithId } from '@payaca/ambrosia';

import { unflattenFolders } from '@payaca/helpers/folderHelper';

export const unflattenFoldersForTreeView = (
  folders: Folder[]
): TreeViewItemWithId[] => {
  const flatTreeViewItems = folders.map((folder) => ({
    id: folder.id,
    parentId: folder.parentId,
    label: folder.name,
    selected: false,
    defaultOpen: false,
    metaData: { isRoot: folder.isRoot },
  }));

  return unflattenFolders(flatTreeViewItems, { ignoreRoot: true });
};
